import script from "./BrandName.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandName.vue?vue&type=script&setup=true&lang=js"

import "./BrandName.vue?vue&type=style&index=0&id=1a181fd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a181fd8"]])

export default __exports__